var disposed = false
function injectStyle (context) {
  if (disposed) return
  require("!!../../../../../../../node_modules/extract-text-webpack-plugin/dist/loader.js?{\"omit\":1,\"remove\":true}!vue-style-loader?sourceMap!css-loader?{\"minimize\":true,\"sourceMap\":true,\"importLoaders\":0}!../../../../../../../node_modules/vue-loader/lib/style-compiler/index?{\"optionsId\":\"0\",\"vue\":true,\"scoped\":false,\"sourceMap\":true}!less-loader?{\"sourceMap\":true}!../../../../../../../node_modules/vue-loader/lib/selector?type=styles&index=0!./vue.vue")
}
/* script */
export * from "!!babel-loader?{\"cacheDirectory\":true}!../../../../../../../node_modules/vue-loader/lib/selector?type=script&index=0!./vue.vue"
import __vue_script__ from "!!babel-loader?{\"cacheDirectory\":true}!../../../../../../../node_modules/vue-loader/lib/selector?type=script&index=0!./vue.vue"
/* template */
var __vue_render__, __vue_static_render_fns__
/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
import normalizeComponent from "!../../../../../../../node_modules/vue-loader/lib/runtime/component-normalizer"
var Component = normalizeComponent(
  __vue_script__,
  __vue_render__,
  __vue_static_render_fns__,
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)
Component.options.__file = "src/VisualCraft/Bundle/VideoJetUserBundle/Resources/js/forgot-credentials/vue.vue"

/* hot reload */
if (module.hot) {(function () {
  var hotAPI = require("vue-hot-reload-api")
  hotAPI.install(require("vue"), false)
  if (!hotAPI.compatible) return
  module.hot.accept()
  if (!module.hot.data) {
    hotAPI.createRecord("data-v-a887cbd4", Component.options)
  } else {
    hotAPI.reload("data-v-a887cbd4", Component.options)
  }
  module.hot.dispose(function (data) {
    disposed = true
  })
})()}

export default Component.exports



//////////////////
// WEBPACK FOOTER
// ./src/VisualCraft/Bundle/VideoJetUserBundle/Resources/js/forgot-credentials/vue.vue
// module id = xDop
// module chunks = 21